// extracted by mini-css-extract-plugin
export var tabLabel = "AzVzVqTAblosysbLae_k";
export var tabLinkActive = "tEfqARaXnn8LeDpXbFfY";
export var tabLinkButton = "wNFu_OR3CLaixOEuNTYO";
export var tabLinkLine = "Jv422jmNJrn1EqgnIg_e";
export var withScroll = "OGtSg_pBiuRQpDwM3daU";